import styled from '@emotion/styled'
import decode from 'unescape'
import { Draggable } from 'react-beautiful-dnd'

import ListItemArtwork from './ListItemArtwork'
import ListItemContainer from './ListItemContainer'

import SvgBandcamp from '../public/images/bandcamp2.svg'
import SvgDelete from '../public/images/delete.svg'

const BandcampLink = styled.a`
  color: ${({ theme }) => theme.colors.bandcampBlue};
`

function Track({ action, data, editMode, i, onDelete, play }) {
  const { artist, image, label, title, url } = data

  return (
    <Draggable draggableId={url} index={i}>
      {(provided) => (
        <ListItemContainer
          className={'opacity-hover-host ' + (editMode ? '' : 'pointer')}
          onClick={!editMode ? play : null}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <div className="flex items-center">
            <ListItemArtwork className="mr4-ns" image={image} />

            <div className="flex flex-column">
              <div className="mb1 f5 f4-ns pr5">
                {decode(artist)} - <br className="db dn-ns" />
                {decode(title)}
              </div>

              {label !== artist && (
                <span className="gray f7 f6-ns fw4 tracked-light">
                  {decode(label)}
                </span>
              )}
            </div>
          </div>

          {editMode
            ? removeIcon(() => {
                onDelete(i)
              })
            : bandcamp(url, action)}
        </ListItemContainer>
      )}
    </Draggable>
  )
}

function removeIcon(onClick) {
  return (
    <button
      className="absolute bg-transparent bn pa0 opacity-hover-child pointer dn db-ns outline-0 top-1 right-1"
      onClick={onClick}
    >
      <SvgDelete />
    </button>
  )
}

function bandcamp(url, action) {
  return (
    <BandcampLink
      className="absolute flex items-center opacity-hover-child tracked-light bottom-1 right-1 no-underline underline-hover"
      href={url}
      onClick={(e) => {
        e.stopPropagation()
        action()
      }}
      rel="noopener noreferrer"
      target="_blank"
    >
      <span className="bandcamp f7 f6-ns mr1 mr2-ns">Buy</span>
      <SvgBandcamp />
    </BandcampLink>
  )
}

export default Track
